import { combineReducers } from 'redux';

import currentUserReducer from './currentUserReducer';
import fieldReducer from './fieldReducer';
import weatherForecastReducer from './weatherForecastReducer';
import pastWeatherReducer from './pastWeatherReducer';
import featureReducer from './featureReducer';
import { RESET_STATE } from '../constants/actionTypes';

const appReducer = combineReducers({
  currentUser: currentUserReducer,
  field: fieldReducer,
  weatherForecast: weatherForecastReducer,
  pastWeather: pastWeatherReducer,
  feature: featureReducer
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    // Preserve feature flags when resetting state
    const featureState = state.feature;
    const newState = appReducer(undefined, action);
    return {
      ...newState,
      feature: featureState
    };
  }

  return appReducer(state, action);
}

export default rootReducer;
